<div class="flex flex-col md:flex-row gap-5" style="min-height: 81vh">
    <div class="flex-1 md:w-2/3 card p-0 meeting-box-card">
        <app-myprofile-box></app-myprofile-box>
    </div>
    <div class="md:w-1/3 card p-0 meeting-sidebar-card">
        <app-myprofile-sidebar></app-myprofile-sidebar>
    </div>
</div>
